import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
  const [dots, setDots] = useState('');
  
  // Animate the dots
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => {
        if (prevDots.length >= 3) return '';
        return prevDots + '.';
      });
    }, 300);
    
    return () => clearInterval(interval);
  }, []);

  // Randomly select a loading message
  const loadingMessages = [
    'Finding tasty options',
    'Checking for the perfect spot',
    'Gathering restaurants',
    'Preparing the wheel',
    'Almost ready',
  ];
  
  const [randomMessage, setRandomMessage] = useState('');
  
  useEffect(() => {
    const messageIndex = Math.floor(Math.random() * loadingMessages.length);
    setRandomMessage(loadingMessages[messageIndex]);
  }, []);

  return (
    <LoadingContainer>
      <SpinnerCircle />
      <LoadingText>
        {message || randomMessage}{dots}
      </LoadingText>
    </LoadingContainer>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 0 auto;
  width: 100%;
`;

const SpinnerCircle = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 90, 95, 0.1);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 1rem;
`;

const LoadingText = styled.div`
  font-size: 1.1rem;
  color: var(--text-color);
  min-height: 1.5rem;
`;

export default LoadingSpinner;